import React from 'react';

import { SSRInlineCommentsInit } from './SSRInlineCommentsInit';

export const SSRInlineScriptsInit = ({}) => {
	return <SSRInlineCommentsInit />;
};
